<template>
  <!--  手表APP-->
  <div class="watchDevice">
    <!-- <div class="rotate-loading" v-if="!visable"></div> -->
    <div class="flex-loading" v-if="!visable">
      <div class="line" style="--time: 1"></div>
      <div class="line" style="--time: 2"></div>
      <div class="line" style="--time: 3"></div>
      <div class="line" style="--time: 4"></div>
      <div class="line" style="--time: 5"></div>
      <div class="line" style="--time: 6"></div>
      <div class="line" style="--time: 7"></div>
      <div class="line" style="--time: 8"></div>
    </div>
    <div v-show="visable">
      <div class="title">{{ langJson[lang].title }}</div>
      <ul>
        <li>
          <div class="top">
            <img :src="imgsrc" alt="" />
            <div class="right">
              <div class="right-top">{{ langJson[lang].name }}</div>
              <p v-html="langJson[lang].detail1"></p>
            </div>
          </div>
          <div class="bottom">
            <div @click="downloadApp(1)" class="btn">
              {{ langJson[lang].download }}
            </div>
          </div>
        </li>
        <li>
          <div class="top">
            <img :src="imgsrc" alt="" />
            <div class="right">
              <div class="right-top">BP Doctor</div>
              <p v-html="langJson[lang].detail2"></p>
            </div>
          </div>
          <div class="bottom">
            <div @click="downloadApp(2)" class="btn">
              {{ langJson[lang].download }}
            </div>
          </div>
        </li>
      </ul>
      <!-- <el-button  v-loading.fullscreen.lock="fullscreenLoading" @click="downloadApp" style="width: 100%;height: 100%;font-size: 25px">
      Click to download
    </el-button> -->
    </div>
  </div>
</template>

<script>
import { isiOS } from "../utils/util";
// import { getAndroidUrl } from "../api/appManageApi";
// import { handleResponse } from "../utils/response";

export default {
  name: "WatchDevice",
  data() {
    return {
      visable: false,
      imgsrc: require("@/images/pic_logo.png"),
      androidUrl: "",
      fullscreenLoading: true,
      lang: "zh",
      langJson: {
        zh: {
          title: "请选择要下载的版本",
          name: "研和健康管家",
          detail1:
            "适用于<span class='blue'> 中国（包括台湾、香港、澳门）</span>用户",
          detail2: "适用于<span class='blue'>国际</span>用户",
          download: "下载",
        },
        tw: {
          title: "請選擇要下載的版本",
          name: "研和健康管家 ",
          detail1:
            "適用於<span class='blue'> 中國（包括台灣、香港、澳門）</span>用戶",
          detail2: "適用於<span class='blue'> 國際</span>用戶",
          download: "下載",
        },
        en: {
          title: "Select version to download",
          name: "研和健康管家",
          detail1:
            "Applicable to users in <span class='blue'>  China  (including Taiwan, Hong Kong, Macau)</span>",
          detail2: "For<span class='blue'> international</span> users",
          download: "Download",
        },
        es: {
          title: "Seleccione la versión para descargar",
          name: "研和健康管家",
          detail1:
            "Aplicable a usuarios en<span class='blue'>  China (incluidos Taiwán, Hong Kong, Macao)</span>",
          detail2: "Para usuarios internacionales",
          download: "Descargar",
        },
        jp: {
          title: "ダウンロードするバージョンを選択してください",
          name: "研和健康管家",
          detail1:
            "<span class='blue'> 中国（台湾、香港、マカオを含む）</span>のユーザーに適用",
          detail2: "国際ユーザー向け",
          download: "ダウンロード",
        },
      },
    };
  },
  methods: {
    downloadApp(num) {
      if (isiOS()) {
        //ios
        if (num == 1) {
          //国内版
          window.location.href = "https://apps.apple.com/app/id1609019773";
        } else {
          window.location.href = "https://apps.apple.com/app/id1518354131";
          //国际版
        }
      } else {
        //android

        if (num == 1) {
          //国内版
          window.location.href =
            "https://cn-android-apk-release.oss-cn-shanghai.aliyuncs.com/yanhejiankangguanjia.apk";
        } else {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.health.yanhenew";

          //国际版
        }
      }

      // window.location.href = this.androidUrl;
    },
  },
  created() {
    const name = this.$route.query.Name;
    if (name?.startsWith("M7000")) {
      setTimeout(() => {
        window.location.href =
          "https://data.zdeer.com/uploads-app/download/ZdeerWatch/index.html";
      }, 1000);
      return;
    } else {
      this.visable = true;
    }
    var lang = window.navigator.language;
    if (lang.includes("zh")) {
      if (lang.includes("HK") || lang.includes("TW")) {
        this.lang = "tw";
      } else {
        this.lang = "zh";
      }
    } else if (/^ja/.test(lang)) {
      this.lang = "jp";
    } else if (lang.includes("es")) {
      this.lang = "es";
    } else {
      this.lang = "en";
    }
  },
  mounted() {
    // if (isiOS()) {
    //   window.location.href =
    //     "https://apps.apple.com/cn/app/bp-doctor/id1518354131";
    // } else {
    //   getAndroidUrl().then((response) => {
    //     this.fullscreenLoading = false;
    //     handleResponse(
    //       response,
    //       (data) => {
    //         this.androidUrl = data.url;
    //         console.log(this.androidUrl);
    //       },
    //       (error) => {}
    //     );
    //   });
    // }
  },
};
</script>

<style lang="less">
@import "../assets/font/font.css";
html {
  font-size: 2.667vw !important;
}
.watchDevice {
  background-color: #fff;
  min-height: 100vh;
  width: 100%;
  .title {
    color: #1c1c1c;
    font-family: pfc;
    padding: 2rem;
    font-size: 1.8rem;
    margin: 0;
  }
  ul {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 2rem;
    padding-top: 0;
    box-sizing: border-box;
    li {
      background-color: #f4f6fa;
      width: 95%;
      list-style: none;
      border-radius: 1.2rem;
      padding: 1.5rem;
      margin-bottom: 1.6rem;

      .top {
        display: flex;
        img {
          width: 4.8rem;
          margin-right: 2rem;
          height: 4.8rem;
        }
        .right {
          flex: 1;
          .right-top {
            font-size: 1.6rem;
            font-family: pfh;
          }
          p {
            font-size: 1.2rem;
            margin-top: 0.5rem;
            line-height: 1.4em;
            color: #333;

            .blue {
              color: #386bf5;
            }
          }
        }
      }
      .bottom {
        text-align: right;
        margin-top: 1.5rem;
        .btn {
          font-size: 1.4rem;
          background-color: #386bf5;
          padding: 0.7rem 2.6rem;
          display: inline-block;
          border-radius: 1.6rem;
          color: #fff;
        }
      }
    }
  }
}

.rotate-loading {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  /* transform: translate(-50%, -50%); */
  margin: -25px;
  border-radius: 50%;
  border: 6px solid rgba(200, 200, 200, 0.5);
  border-top: 6px solid black;
  animation: rotate-loading 1s linear infinite;
}

@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    /* 顺时针旋转360度 */
    transform: rotate(360deg);
  }
}

.flex-loading {
  width: 65px;
  height: 36px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.flex-loading .line {
  width: 4px;
  height: 12px;
  display: inline-block;
  background: #000;
  margin: 0 2px;
  /* 动画名：flex-loading，
             * 执行时长：0.8s，
             * 动画执行速度：ease-in-out(指定开始和结束较慢的动画)，
             * 动画执行次数：infinite(无限次) */
  animation: flex-loading 0.8s ease-in-out infinite;
  /* 每个小格子的伸缩动画分别延迟0.1s，0.2s，0.3s...执行，
             * var(--time)使用CSS3变量 */
  animation-delay: calc(0.1s * var(--time));
}

@keyframes flex-loading {
  0%,
  25%,
  50% {
    transform: scaleY(1);
  }
  /* 小格子纵向伸展到原来的4倍 */
  75% {
    transform: scaleY(4);
  }
}
</style>
